// !IMPORTANT!
//
// These validation functions are only intended to help the user input correct data, with the assumption
// that the correct data is already known.
// They only need to adhere to the minimum requirements for automatic features in DanaService to work
//
// If more strict variations are needed (like an e-mail address that won't get an error from a
import { RegexPatterns } from "constants/RegexPatterns";

// SMTP server, etc., that should probably be added as a separate validator, rather than replacing the existing
export { };

declare global {
	interface String {
		isValidEmailAddress: () => boolean;
		isValidPhoneNumber: () => boolean;
		isMobileNumber: () => boolean;
		isValidVatNumber: () => boolean;
		isValidZipcode: () => boolean;
		isValidDomainNonDk: () => boolean;
		isValidDomainDk: () => boolean;
		isValidDomain: () => boolean;
		isValidPercent: () => boolean;
		isValidPrice: () => boolean;
		isValidEan13: () => boolean;
		isValidFolder: () => boolean;
	}
}
String.prototype.isValidEmailAddress = function(): boolean {
	return (this.match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/) != null);
};
String.prototype.isValidPhoneNumber = function(): boolean {
	return (this.match(/^[0-9 ()+-]+$/) != null);
};
String.prototype.isMobileNumber = function (): boolean {
	return (this.match(RegexPatterns.isMobileNumber) != null);
};
String.prototype.isValidZipcode = function(): boolean {
	return (this.match(/^[0-9]+$/) != null);
};
String.prototype.isValidVatNumber = function (): boolean {
	return (this.match(/^[0-9]{1,8}$/) != null);
};
String.prototype.isValidDomain = function (): boolean {

	// Calidatation against IDN-compatible UniCode domains (so not the punycode variant)
	// 1. A set of lookaheads preventing hyphen (-) at the start, or two consecutive hyphens (--) in positions 3+4 (reserved for IDN encoding). Also prevents ".." or "-." sequences anywhere in the domain
	// 2. Accept 1 or 2 domain parts (e.g. "example." or "submdomain.example.") not leading into a subsequent starting hyphen
	//    - Whitelists most common UniCode characters accepted by IDN - See: https://www.iana.org/assignments/idna-tables-12.0.0/idna-tables-12.0.0.xhtml#idna-tables-properties
	//    - This also includes UpperCase variants, which is why we also validate against capital letters
	// 3. Accept any TLD of 2 or more characters (e.g. ".com", ".dk", ".co.uk", etc.)
	return (
		this.toLowerCase() === this &&
		this.match(/^(?!(-|..--))(?!.*\.\.)(?!.*\-\.)([a-z0-9\u00DF-\u00F6\u00F8-\u02AF\u0430-\u052F\u1DFB-\u1F07\-]+(\.(?!-))){1,2}[a-zA-Z]{2,}$/) != null
	);
};
String.prototype.isValidDomainNonDk = function (): boolean {
	return this.isValidDomain() && !this.endsWith('.dk');
};
String.prototype.isValidDomainDk = function (): boolean {
	return this.isValidDomain() && this.endsWith('.dk');
};
String.prototype.isValidPercent = function (): boolean {
	return (this.match(/^((100)|(\d{0,2}))%?$/) != null);
};
String.prototype.isValidPrice = function (): boolean {
	return (this.match(/^\d+(\,\d{1,2})?$/) != null);
};
String.prototype.isValidEan13 = function (): boolean {

	// Inspiration source: https://www.npmjs.com/package/barcoder?activeTab=code
	if (this.match(/^\d{13}$/) == null) return false;

	let checksum = 0;
	let barcode = [...this].map(Number).reverse();
	let controlDigit = barcode.shift();

	barcode.forEach((digit, index)=> {
		checksum += (index % 2) === 0 ? 3 * digit : digit;
	});
	
	checksum = (checksum % 10);
	if (checksum !== 0) checksum = 10 - checksum;
	return controlDigit === checksum
};
String.prototype.isValidFolder = function (): boolean {
	return (this.match(/^[^\\/:*?"<>|]+$/) != null && this != '.' && this != '..' && this.match(/^\s/) == null && this.match(/[.\s]$/) == null);
};
